import React, { useEffect } from 'react';
import { Layout } from 'antd';
import { useLocation } from 'react-router-dom';
import { Hero } from '../sections/accueil/Hero';
import { CtaBanner } from '../sections/accueil/CtaBanner';
import { Parcours } from '../sections/accueil/Parcours';
import { Stats } from '../sections/accueil/Stats';
import { InfoSection } from '../sections/accueil/InfoSection';
import { ProjectSection } from '../sections/accueil/ProjectSection';
import { HelpSection } from '../sections/accueil/HelpSection';
import { handleAnchorFromURL } from '../utils/navigation';

export const HomePage: React.FC = () => {
  const location = useLocation();

  // Gérer le scroll vers les ancres après navigation
  useEffect(() => {
    handleAnchorFromURL(location.hash);
  }, [location.hash]);

  return (
    <Layout.Content role="main" aria-label="Contenu principal de la page d'accueil">
      <Hero />
      <CtaBanner />
      <Parcours />
      <Stats />
      <InfoSection />
      <ProjectSection />
      <HelpSection />
    </Layout.Content>
  );
};